import tw from 'tailwind-styled-components'

const ActiveButton = tw.span`
py-2
px-3.5
border
rounded-lg
h-[38px]
inline-flex
items-center 
justify-center
font-bold
text-[11px]
cursor-pointer
hover:brightness-90
w-[57px]
text-darkGray/30 
border-darkGray/30
transition-colors
`

const InactiveButton = tw.span`
py-2
px-3.5
border
rounded-lg
h-[38px]
inline-flex
items-center 
justify-center
font-bold
text-[11px]
cursor-pointer
hover:brightness-90
w-[68px]
text-darkGray/30 
border-darkGray/30
transition-colors
`

export { ActiveButton, InactiveButton }
